export const toUnixTimestamp = (date: string | Date): number => {
  return Math.floor(new Date(date).getTime() / 1000);
};
